export enum SettingsRoutes {
  general = '/settings/general',
  website = '/settings/website',
  admins = '/settings/admins',
  menu = '/settings/menu',
  security = '/settings/security',
  account = '/settings/account'
}
